import { Component, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { LanguageHandler } from 'src/app/util/language-handler';
import { TranslocoService } from '@jsverse/transloco';
import { CreateDocTdRequestDto } from 'src/app/data-transfer/entities/doc-entities/create-doc-td-request';
import { CreateDocPreRequestDto } from 'src/app/data-transfer/entities/doc-entities/create-doc-pre-request-dto';
import { DatasetProfileDto } from 'src/app/data-transfer/entities/doc-entities/dataset-profile-dto';
import { PathResolveService } from 'src/app/services/path-resolve.service';

export interface CreateDocTdDialogData {
  mode: 'doc' | 'td';
  packagingElements: CreateDocPreRequestDto[];
  tdProfiles?: DatasetProfileDto[];
}

@Component({
  selector: 'app-create-doc-td-dialog',
  templateUrl: './create-doc-td-dialog.component.html',
  styleUrls: ['./create-doc-td-dialog.component.scss'],
})
export class CreateDocTdDialogComponent {
  readonly noTdProfileId = '';
  countryCodes: string[] = [];
  tdProfiles: DatasetProfileDto[];

  form: FormGroup<{
    languageCode: FormControl<string>;
    tdProfileId: FormControl<string>;
  }>;

  private languageHandler: LanguageHandler;

  constructor(
    private dialogRef: MatDialogRef<CreateDocTdDialogComponent>,
    private dialog: MatDialog,
    private fb: FormBuilder,
    private translateService: TranslocoService,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: CreateDocTdDialogData
  ) {
    this.languageHandler = new LanguageHandler(this.translateService);
    this.countryCodes = this.languageHandler.getLanguageCodes().filter(code => code === 'de' || code === 'gb');
    this.tdProfiles = data.tdProfiles ?? [];
    this.form = this.fb.group({
      languageCode: new FormControl<string>('gb', { nonNullable: true }),
      tdProfileId: new FormControl<string>(this.noTdProfileId, { nonNullable: true }),
    });
  }

  get isDoc(): boolean {
    return this.data.mode === 'doc';
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  clickPpwrProfiles(): void {
    this.dialog.closeAll();
    const path = PathResolveService.getProfilesPath(true);
    this.router.navigate([path]);
  }

  onCreate(): void {
    const tdProfileId = this.form.getRawValue().tdProfileId;
    const result: CreateDocTdRequestDto = {
      language: this.form.getRawValue().languageCode === 'gb' ? 'en' : this.form.getRawValue().languageCode,
      packagingElements: this.data.packagingElements,
      tdProfileId: this.isDoc || tdProfileId === this.noTdProfileId ? null : tdProfileId,
    };
    this.dialogRef.close({ confirmed: true, ...result });
  }
}
